export default "__VITE_ASSET__hbM5toRL__"